<template>
    <div class="disease-doctor">
        <section
            v-for="item in sections"
            :id="item.id"
            :key="item.key"
            class="doctor-section"
        >
            <div class="section-head">
                <h3 class="section-tit">{{ item.title }}</h3>
            </div>
            <div class="section-body">
                <medicine-analysis v-if="item.key === 'medicine'" />
                <treatment-analysis v-else-if="item.key === 'treatment'" />
                <pathogenesis-analysis v-else-if="item.key === 'pathogenesis'" />
                <diagnosis-analysis v-else-if="item.key === 'diagnosis'" />
            </div>
        </section>
    </div>
</template>

<script>
import MedicineAnalysis from './comps/medicine_analysis.vue';
import TreatmentAnalysis from './comps/treatment_analysis.vue';
import PathogenesisAnalysis from './comps/pathogenesis_analysis.vue';
import DiagnosisAnalysis from './comps/diagnosis_analysis.vue';

export default {
    name: 'DiseaseDoctor',
    components: {
        MedicineAnalysis,
        TreatmentAnalysis,
        PathogenesisAnalysis,
        DiagnosisAnalysis,
    },
    data() {
        return {
            sections: [
                { key: 'medicine', id: 'medicineAnalysis', title: '用药分析' },
                { key: 'treatment', id: 'treatmentAnalysis', title: '治疗分析' },
                { key: 'pathogenesis', id: 'pathogenesisAnalysis', title: '病因病机分析' },
                { key: 'diagnosis', id: 'diagnosisAnalysis', title: '诊断分析' },
            ],
        };
    },
};
</script>

<style lang="less" scoped>
@import './index.less';
</style>
